// components/SQLStatementTab.tsx
import React, { useState } from 'react';
import { formatSQL } from '../utils/sqlFormatter';
import './SQLStatement.css';
import './ChatMessage.css';
import {
  IconFileCode,
  IconCopy,
} from '@cimpress-technology/react-streamline-icons/lib';

interface OnlySQLStatementTabProps {
  message: any;
  executeSQLStatement: any;
}

const OnlySQLStatementTab: React.FC<OnlySQLStatementTabProps> = ({
  message,
  executeSQLStatement,
}) => {
  const [copied, setCopied] = useState(false);
  const hasSqlQuery = message.sql;
  const localPromptId = message.prompt_id;

  const handleButtonClick = () => {
    executeSQLStatement(null, localPromptId, hasSqlQuery);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(message.sql);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="chat-message-container">
      <br />
      <h4>Only SQL Statement</h4>
      <br />

      {/* SQL Query Tab */}
      {hasSqlQuery && (
        <div className="tab-content">
          <button className="execute-sql-button" onClick={handleButtonClick}>
            <IconFileCode
              style={{ color: '#E17055', height: '40px' }}
              className="tab-icon"
              weight="fill"
            />
            <span className="tab-text">Execute SQL Query</span>
          </button>
          <div className="sql-query-message">
            <div className="icon-text-container">
              <h4>
                <b>SQL Query:</b>
              </h4>
            </div>
            <div className="query-block-container">
              <button
                className="copy-button"
                onClick={handleCopy}
                title="Copy SQL"
              >
                <IconCopy style={{ color: '#fff', height: '16px' }} />
                {copied ? 'Copied!' : 'Copy'}
              </button>
              <pre className="query-block">
                <code
                  dangerouslySetInnerHTML={{ __html: formatSQL(message.sql) }}
                />
              </pre>
            </div>
          </div>
        </div>
      )}

      {/* Fallback message if no SQL statement */}
      {!hasSqlQuery && (
        <div className="no-query-message">
          <p>No SQL query available.</p>
        </div>
      )}
    </div>
  );
};

export default OnlySQLStatementTab;
